import './login.scss';
import React from 'react';
import { Alert, Button, Col, Form, Input, Row } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Translate, translate } from 'react-jhipster';
import { useForm } from 'react-hook-form';

export interface ILoginPageProps {
  loginError: boolean;
  handleLogin: (username: string, password: string, rememberMe: boolean) => void;
}
const LoginPage = (props: ILoginPageProps) => {
  const login = ({ username, password, rememberMe }) => {
    props.handleLogin(username, password, rememberMe);
  };

  const {
    handleSubmit,
    register,
    formState: { errors, touchedFields },
  } = useForm({ mode: 'onTouched' });

  const { loginError } = props;

  return (
    <div className="container">
      <Row className="mt-4 logo"></Row>
      <Row className="justify-content-center mt-4">
        <Col xs={20} sm={8} span={8}>
          <Form name="normal_login" className="login-form " layout="vertical" initialValues={{ remember: true }} onFinish={login}>
            {loginError ? (
              <Alert
                message="Échec de la connexion !"
                description="Veuillez vérifier vos informations d'identification et réessayer"
                type="error"
              />
            ) : null}

            <Form.Item
              name="username"
              rules={[{ required: true, message: 'Veuillez saisir votre nom utilisateur' }]}
              label={translate('global.form.username.label')}
              data-cy="username"
            >
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder={translate('global.form.username.placeholder')}
                autoFocus
                onTouchStart={touchedFields.username}
                onError={errors.username}
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Veuillez saisir votre mot de passe' }]}
              label={translate('login.form.password')}
              data-cy="password"
            >
              <Input
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder={translate('login.form.password.placeholder')}
                onTouchStart={touchedFields.password}
                onError={errors.password}
              />
            </Form.Item>
            <Form.Item style={{ textAlign: 'center' }}>
              <Button
                style={{ backgroundColor: '#F28E19', borderRadius: 5, width: 'auto', fontWeight: 'bold' }}
                htmlType="submit"
                size="middle"
                className="login-form-button"
                data-cy="submit"
              >
                <Translate contentKey="login.form.button">Sign in</Translate>
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default LoginPage;
